import utils = egr.wcf.utils;
import { parseQueryString } from '../submodules/utils/Url';
import { Dict } from '../submodules/utils/Types';
// import { loadHiddenFrame } from '../submodules/utils/Download';

const externalLoginUrl: string = 'https://www.bpro-solutions.com/partnerportal/login?site=DE';
const externalTokenVerifyUrl: string = 'https://www.bpro-solutions.com/partnerportal/rest/token/verify?site=DE&application=configurator&startup=';
// const externalLogoutUrl: string = 'https://hybbpd.bfits.com/partnerportal/logout?site=DE';

export interface Payload {
    nonce: string;
}

async function decodePayload<T extends Payload>(token: string, gracePeriod: number = 3600): Promise<T | null> {
    const ajaxOptions: utils.async.AjaxOptions = {
        headers: {
            Authorization: 'Bearer ' + token
        }
    };

    const args: Dict = parseQueryString(window.location.hash.substr(1));

    let verifyUrlInclStartup: string = externalTokenVerifyUrl;
    if (!utils.string.isNullOrEmpty(args.startup)) {
        verifyUrlInclStartup += args.startup;
    }

    const verifyResponse: boolean = await utils.async.ajax<boolean>('GET', verifyUrlInclStartup, null, ajaxOptions);

    if (verifyResponse === true) {
        return { nonce: token } as T;
    }

    return null;
}

export function getUserInfo<T extends Payload>(): Promise<T | null> {
    const args: Dict = parseQueryString(window.location.hash.substr(1));
    if (!utils.string.isNullOrEmpty(args.token)) {
        return decodePayload(args.token);
    }

    return Promise.resolve<null>(null);
}

export async function login(): Promise<void> {
    document.location.href = externalLoginUrl;

    return new Promise<void>((): void => {
        // never resolve
    });
}

export function logout(): void {
    const reloadUrl: string = document.location.protocol + '//' + document.location.host;
    document.location.href = reloadUrl;
    // loadHiddenFrame(externalLogoutUrl, 5000);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/ExternalCustomerLogin.ts